import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getResourceLibraryMetadata } from "@/modules/hub/features/ResourceLibrary/api/getResourceLibraryMetadata/getResourceLibraryMetadataApi";
import { ResourceLibraryMetadataFilters } from "@/modules/hub/features/ResourceLibrary/api/getResourceLibraryMetadata/types";

interface PartnerNetworkMetadataState {
  metadata: ResourceLibraryMetadataFilters | null;
  loadingGet: boolean;
  error: string | null;
}

const initialState: PartnerNetworkMetadataState = {
  metadata: null,
  loadingGet: false,
  error: null,
};

export const getPartnerNetworkMetadataAction = createAsyncThunk(
  "partnerNetworkMetadata/get",
  async () => {
    const response = await getResourceLibraryMetadata();
    return response.data.filters;
  },
);

const partnerNetworkMetadataSlice = createSlice({
  name: "partnerNetworkMetadata",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPartnerNetworkMetadataAction.pending, (state) => {
        state.loadingGet = true;
        state.error = null;
      })
      .addCase(getPartnerNetworkMetadataAction.fulfilled, (state, action) => {
        state.metadata = action.payload;
        state.loadingGet = false;
      })
      .addCase(getPartnerNetworkMetadataAction.rejected, (state, action) => {
        state.loadingGet = false;
        state.error = action.error.message || "Failed to fetch metadata";
      });
  },
});

export default partnerNetworkMetadataSlice.reducer;
